import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckPay = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Capa_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 800 625.28",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("style", { children: "\n      .check-pay-fill {\n        fill: url(#linear-gradient-check-pay);\n      }\n    " }), /* @__PURE__ */ _jsxs("linearGradient", {
		id: "linear-gradient-check-pay",
		x1: 10.15,
		y1: 312.64,
		x2: 789.85,
		y2: 312.64,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#001fd0"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .07,
				stopColor: "#002cd6"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .25,
				stopColor: "#004be6"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .41,
				stopColor: "#005eef"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .52,
				stopColor: "#0165f3"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .67,
				stopColor: "#0d77f5"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .84,
				stopColor: "#1683f6"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#1a88f7"
			})
		]
	})] }), /* @__PURE__ */ _jsx("polygon", {
		className: "check-pay-fill",
		points: "789.85 106.01 281.13 614.73 185.43 519.28 10.15 344 105.85 248.31 281.13 423.58 694.4 10.56 789.85 106.01"
	})]
});
export default SvgCheckPay;
